import consumer from "./consumer";

consumer.subscriptions.create("WebNotificationsChannel", {
  connected() {
    console.log('WebNotificationsChannel::Connected');
  },

  disconnected() {},

  received(data) {
    console.log('WebNotificationsChannel::Received', data);

    if (data.unread_messages) {
      const $menu = $('.user-menu');
      $menu.find('.label')
        .text(data.unread_messages)
        .removeClass('hidden');
    }

    if (data.notification_type === 'announcement') {
      // if (data.sender_id == window.App.user_id) { return; }

      const message = data.message;
      const broadcast_to_all = data.broadcast;
      const is_recipient = data.recepients.includes(window.App.user_id);
      console.log('is_recipient', is_recipient);

      if (broadcast_to_all || is_recipient) {
        window.notify(message, {
          type: 'warning',
          layout: 'top',
          timeout: false,
          modal: false,
          buttons: false,
          closeWith: ['click']
        });
      }
    }
  }
});
